import { Injectable } from '@angular/core';

import { CurrentUser } from '../../../features/auth/models/current-user.model';

const ACCESS_TOKEN_KEY = 'gcc_access_token';
const CURRENT_USER_KEY = 'gcc_current_user';

@Injectable({ providedIn: 'root' })
export class TokenStorageService {
  // Centraliza o acesso ao localStorage para manter componentes e guards sem persistencia direta.
  public saveAccessToken(accessToken: string): void {
    this.setItem(ACCESS_TOKEN_KEY, accessToken);
  }

  public getAccessToken(): string | null {
    return this.getItem(ACCESS_TOKEN_KEY);
  }

  public saveCurrentUser(user: CurrentUser): void {
    this.setItem(CURRENT_USER_KEY, JSON.stringify(user));
  }

  public getCurrentUser(): CurrentUser | null {
    const storedUser = this.getItem(CURRENT_USER_KEY);

    if (!storedUser) {
      return null;
    }

    try {
      return JSON.parse(storedUser) as CurrentUser;
    } catch {
      this.clear();
      return null;
    }
  }

  public clear(): void {
    this.removeItem(ACCESS_TOKEN_KEY);
    this.removeItem(CURRENT_USER_KEY);
  }

  private getItem(key: string): string | null {
    if (!this.isStorageAvailable()) {
      return null;
    }

    return localStorage.getItem(key);
  }

  private setItem(key: string, value: string): void {
    if (!this.isStorageAvailable()) {
      return;
    }

    localStorage.setItem(key, value);
  }

  private removeItem(key: string): void {
    if (!this.isStorageAvailable()) {
      return;
    }

    localStorage.removeItem(key);
  }

  private isStorageAvailable(): boolean {
    return typeof localStorage !== 'undefined';
  }
}
